<template>
  <div>
    <block :nobody="true" ref="buser" class="soft-control">
      <soft-table
        @rowSelected="tbSetRowSelected"
        @rowClicked="tbRowClicked"
        class="table align-items-center table-flush"
        tbody-classes="list"
        :pending="false"
        :dataTable="productSpecifys"
        :fields="fields"
        :minHeight="$hMainContent - 69"
        :showAll="true"
        :norecordAdd="handleAddNew"
        :noDelete="true"
        @doEditRow="handleEdit"
        @contextMenuItemClick="tbHandleContextMenuItemClick"
        ref="soft-table"
      >
        <template v-slot:cell(name)="{ value, item }">
          <span class="badge badge-primary ml-1"> {{ value }} mm </span>
          <span
            v-if="item.color"
            style="padding:3px 10px; margin-left:5px ; border-radius:5px; color:#bbbbbb; margin-right:5px; border:1px solid gray"
            :style="`background:${item.color.color}`"
          >
            {{ item.color.label }}
          </span>
        </template>
      </soft-table>
      <div class="p-1">
        <control-mini
          :countChecked="countChecked"
          @search="handleSearch"
          :noDelete="true"
          :noAdd="true"
          :noEdit="true"
        >
        </control-mini>
      </div>
    </block>
    <spec-modal ref="specModal"></spec-modal>
    <spec-feature-modal ref="specFeatureModal"></spec-feature-modal>
  </div>
</template>
<script>
// import { productService } from "@/_services";
import SpecModal from "./__SpecModal";
import SpecFeatureModal from "./__SpecFeatureModal";
export default {
  props: {},
  components: { SpecModal, SpecFeatureModal },
  data() {
    return {
      productSpecifys: [],
      productSpecifysAll: [],
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "checkbox"
        },
        {
          stickyColumn: true,
          key: "name",
          label: "Quy cách",
          sortable: true
        }
      ],
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      info: {},
      product: {}
    };
  },
  mounted() {},
  methods: {
    setData(product) {
      this.product = product;
      this.lastIndexCustomerSelected = 0;
      let productSpecifys = product.productSpecifys;
      let arr = [],
        arrKey = [],
        ix = 0;
      for (let i = 0; i < productSpecifys.length; i++) {
        const element = productSpecifys[i];
        let tmp = arrKey[element.name + "_" + element.color.key];
        if (tmp == undefined) {
          arrKey[element.name + "_" + element.color.key] = ix;
          arr[ix] = {
            key: element.name + "_" + element.color.key,
            name: element.name,
            color: element.color,
            spec: element,
            childs: [element]
          };
          ix++;
        } else {
          arr[tmp].childs.push(element);
        }
      }
      this.productSpecifys = arr;
      this.productSpecifysAll = arr;

      this.$refs["soft-table"].selectRow(this.lastIndexCustomerSelected);
      this.countChecked = 0;
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      if (keyword == "") {
        this.productSpecifys = this.productSpecifysAll;
      } else {
        this.productSpecifys = this.productSpecifysAll.filter(item => {
          //let keys = Object.keys(item)
          let keysCheck = ["name"];
          for (let i = 0; i < keysCheck.length; i++) {
            const key = keysCheck[i];
            let value = item[key];
            if (
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(keyword.toLowerCase())
            ) {
              return true;
            }
          }
          return false;
        });
      }
      if (this.productSpecifys.length > 0) {
        this.$refs["soft-table"].selectRow(0);
        this.$emit("tbRowClicked", this.product, this.productSpecifys[0], 0);
      } else {
        this.$emit("tbRowClicked", this.product, { childs: [] }, 0);
      }
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
      this.$emit("specProductSelected", this.product, item, index);
    },
    tbRowHandleFeatureInfo(item) {
      this.$refs.specFeatureModal.visible = true;
      this.$refs.specFeatureModal.setData(this.product, item);
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == "spec_feature") {
        this.$refs.specFeatureModal.visible = true;
        this.$refs.specFeatureModal.setData(this.product, a.data);
      } else if (a.menu.key == "copy") {
        let newItem = Object.assign({}, a.data);
        delete newItem.id;
        this.$refs.specModal.visible = true;
        this.$refs.specModal.setData(this.product, newItem);
      } else if (a.menu.key == "edit") {
        this.$refs.specModal.visible = true;
        this.$refs.specModal.setData(this.product, a.data);
      } else if (a.menu.key == "new") {
        this.handleAddNew();
      }
    },
    handleEdit() {
      this.$refs.specModal.visible = true;
      this.$refs.specModal.setData(this.product, this.info);
    },
    handleAddNew() {
      this.$refs.specModal.visible = true;
      this.$refs.specModal.setData(this.product, false);
    },
    handleCopy() {},
    handleHelp() {
      alert("help");
    },
    handleDeletes() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.countChecked = items.length;
    }
  }
};
</script>
